<template>
    <v-slide-y-transition>
        <v-container v-if="showBanner && settings" class="pt-4 pb-0">
            <div class="app-alert-banner d-flex align-center pa-4">
                <v-icon color="#004136" class="mr-3" size="22">fal fa-info-circle</v-icon>
                <div class="app-alert-banner__content">
                    <strong v-if="settings.alertTitle">{{ settings.alertTitle }}</strong>
                    <span style="white-space: pre-line;">{{ settings.alert }}</span>
                    <a
                        v-if="settings.alertLink"
                        :href="settings.alertLink"
                        target="_blank"
                        class="app-alert-banner__link"
                    >{{ settings.alertLink }}</a>
                </div>
                <v-btn icon small class="ml-3" @click="dismissAlert" color="#004136">
                    <v-icon size="18">fal fa-times</v-icon>
                </v-btn>
            </div>
        </v-container>
    </v-slide-y-transition>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: "AppAlert",
    data: () => ({
        showBanner: false,
    }),
    mounted() {
        this.$store.dispatch('getSettings');
    },
    watch: {
        settings() {
            this.checkForAlert();
        },
    },
    computed: {
        ...mapState({
            settings: state => state.general.settings,
        })
    },
    methods: {
        checkForAlert() {
            if (!this.settings || !this.settings.alert) {
                this.showBanner = false;
                return;
            }

            if (this.settings.alertEndDate && new Date(this.settings.alertEndDate) < new Date()) {
                this.showBanner = false;
                return;
            }

            if (this.settings.alertEndDate && new Date(this.settings.alertEndDate) < new Date()) {
                this.showDialog = false;
                return;
            }

            let appAlert = encodeURIComponent(this.settings.alert);
            let oldAlert = this.getCookie("appAlert");

            if (oldAlert === appAlert) {
                this.showBanner = false;
                return;
            }

            this.showBanner = true;
        },
        dismissAlert() {
            this.showBanner = false;

            if (this.settings && this.settings.alert) {
                let appAlert = encodeURIComponent(this.settings.alert);
                this.setCookie("appAlert", appAlert, 365);
            }
        },
        setCookie(cname, cvalue, exdays) {
            const d = new Date();
            d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            let expires = "expires="+d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        },
        getCookie(cname) {
            let name = cname + "=";
            let ca = document.cookie.split(';');
            for(let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        },
    }
}
</script>

<style scoped>

</style>
